<template>
  <main>
    <page-header-compact>
      Registro de Resultados laboratorio
    </page-header-compact>

    <div class="container-fluid">
      <!-- PATIENT & ORDER SUMMARY -->
      <div class="card border-left-lg border-left-primary mt-4">
        <div class="card-body p-3">
          <div class="row align-items-center">
            <div class="col-lg-7">
              <div class="d-flex align-items-center">
                <div class="bg-white rounded-circle d-flex align-items-center justify-content-center mr-3 border"
                  style="width: 50px; height: 50px;">
                  <i class="far fa-user text-primary fa-lg"></i>
                </div>
                <div v-if="Object.keys(usuario).length">
                  <div class="text-xs text-uppercase font-weight-600 text-primary mb-1">Datos del Paciente</div>
                  <h5 class="mb-0 font-weight-bold text-dark">
                    {{ usuario.nombre_1 }} {{ usuario.nombre_2 }} {{ usuario.apellido_1 }} {{ usuario.apellido_2 }}
                  </h5>
                  <div class="small text-gray-600 mt-1">
                    <span class="font-weight-bold border-right pr-2 mr-2">
                      {{ usuario.tipo_documento_rel ? usuario.tipo_documento_rel.abreviacion : '' }} {{
                        usuario.documento }}
                    </span>
                    <span>
                      <i class="far fa-calendar-alt mr-1"></i> {{ usuario.years }} Años ({{ usuario.fecha_nacimiento |
                        formatDate }})
                    </span>
                       
                  </div>
                   <div>
                    <span class="badge badge-light border font-weight-bold mt-2 px-2 py-1" style="font-size: 0.75rem; letter-spacing: 0.2px;">
                                <i class="fas fa-shield-alt mr-1 text-muted"></i> EPS: {{ ordentrabajo.eps ? ordentrabajo.eps.DESEPS : 'Sin EPS' }}
                              </span>
                  </div>
                  <div>
                    <span class="badge badge-light text-bold mt-2 font-weight-bold" v-if="ordentrabajo && ordentrabajo.sede">
                              <i class="fas fa-building mr-1"></i> {{ ordentrabajo.sede.NOMBRE_SEDE  }}
                            </span>
                  </div>
                 
                </div>
                <div v-else class="text-muted small italic">
                  <i class="fas fa-info-circle mr-1"></i> Seleccione una orden para ver los datos del paciente
                </div>
              </div>
            </div>
            <div class="col-lg-5 pl-lg-4">
              <div class="row no-gutters">
                <div class="col-6 pr-2">
                  <label class="text-xs text-uppercase font-weight-bold text-muted mb-1">No. Orden de Trabajo</label>
                  <orden-trabajo-field :isSearch="true" ref="ordenTrabajoField" v-model="ordentrabajo"></orden-trabajo-field>
                </div>
                <div class="col-4 bg-light rounded-lg px-2 mx-4">
                  <label class="text-xs text-uppercase font-weight-bold text-gray-600 mb-1">No. Muestra</label>
                  <div class="h5 mb-0 font-weight-bold text-dark">{{ toma_muestra || '---' }}</div>
                </div>
                <div class="col-12 mt-2">
                  <label class="text-xs text-uppercase font-weight-bold text-muted mb-1">Fecha de Registro</label>
                  <input v-model="fecha" class="form-control form-control-sm bg-white" type="date"
                    style="border-radius: 5px;" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-show="!areas.length" class="alert alert-warning border-left-lg shadow-sm mt-4">
        <div class="d-flex align-items-center">
          <i class="fas fa-exclamation-triangle mr-3 fa-lg"></i>
          <div>
            <h6 class="mb-0 font-weight-bold">Esperando información</h6>
            <p class="mb-0 small">Por favor, cargue una orden de trabajo válida para comenzar el registro de resultados.
            </p>
          </div>
        </div>
      </div>

      <!-- AREAS & EXAMS TABS -->
      <div class="card mt-2">
        <div class="card-header border-bottom">
          <div v-show="areas.length">
            <ul class="nav nav-tabs card-header-tabs" id="pills-tab" role="tablist">
              <li v-for="(area, i) in areas" :key="area.id" class="nav-item">
                <a :id="`nav_${area.id}`" :class="{ active: i === 0 }" :href="`#tab_${i}`"
                  class="nav-link text-uppercase font-weight-bold small px-3 mr-2" data-toggle="tab" role="tab">
                  {{ area.nombre }}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="card-body">
          <div class="tab-content" id="nav-tabContent">
            <div v-for="(area, i) in areas" :id="`tab_${i}`" :key="`tab_${area.id}`" :class="{ 'show active': i === 0 }"
              class="tab-pane fade" role="tabpanel">
              <div class="card-header bg-gray-100">
                <div class="row align-items-center no-gutters text-uppercase font-weight-bold text-gray-600"
                  style="font-size: 0.7rem; letter-spacing: 0.05em;">
                  <div class="col-lg-3 d-flex align-items-center">
                    <div v-if="_can('deleted.results')" class="mr-2 flex-shrink-0" style="width: 24px;">
                      <div v-if="hasDeletableItems(area)" class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="`select_all_${area.id}`"
                          :checked="isAreaAllSelected(area)"
                          @change="toggleSelectArea(area, $event)"
                        />
                        <label class="custom-control-label cursor-pointer" :for="`select_all_${area.id}`"></label>
                      </div>
                    </div>
                    <span>Determinación</span>
                  </div>
                  <div class="col-lg-3 text-center">Resultado</div>
                  <div class="col-lg-3 px-3">Observaciones</div>
                  <div class="col-lg-3 text-right pr-3 d-flex justify-content-end align-items-center">
                    <button
                      v-if="_can('deleted.results') && getSelectedForArea(area).length > 0"
                      type="button"
                      class="btn btn-danger btn-xs font-weight-bold shadow-xs py-1 px-2 d-inline-flex align-items-center"
                      style="font-size: 0.72rem; letter-spacing: 0; text-transform: none;"
                      @click="abrirModalEliminar(getSelectedForArea(area))"
                      title="Anular exámenes seleccionados de esta área"
                    >
                      <i class="fas fa-trash-alt mr-1"></i> Eliminar seleccionados ({{ getSelectedForArea(area).length }})
                    </button>
                    <span v-else>Valores Referencia</span>
                  </div>
                </div>
              </div>

              <div class="list-group p-2">
                <div v-for="(entry, index) in area.items" :key="index">

                  <!-- CASE: GROUP -->
                  <template v-if="entry.type === 'group'">
                    <div class="bg-gray-200 px-3 py-2 border-bottom text-xs font-weight-bold text-dark small text-uppercase"
                      >
                      <i class="fas fa-list-ul text-primary mr-2"></i> {{ entry.nombre }}
                    </div>
                    <div v-for="examen in entry.items" :key="examen.id"
                      class="list-group-item px-3 py-1 border-bottom border-light">
                      <div class="row align-items-center no-gutters">
                        <div class="col-lg-3 d-flex align-items-center pl-3">
                          <div v-if="_can('deleted.results')" class="mr-2 flex-shrink-0" style="width: 24px;">
                            <div v-if="examen.id_detalle_resultado" class="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                class="custom-control-input"
                                :id="`check_examen_${examen.id}`"
                                :value="examen"
                                v-model="selectedDetalles"
                              />
                              <label class="custom-control-label cursor-pointer" :for="`check_examen_${examen.id}`"></label>
                            </div>
                          </div>
                          <span class="font-weight-bold text-gray-700 text-sm">{{ examen.nombre }}</span>
                        </div>
                        <div class="col-lg-3">
                          <texto v-if="examen.tipo === 'texto'" v-model="examen.resultado" :validado="examen.validado"></texto>
                          <numerico v-if="examen.tipo === 'numero'" v-model="examen.resultado" :validado="examen.validado"></numerico>
                          <opciones v-if="examen.tipo === 'opcion'" v-model="examen.resultado"
                            :examen="examen.examen_rel" :validado="examen.validado"></opciones>
                        </div>
                        <div class="col-lg-3 px-3 d-flex align-items-center">
                          <textarea v-model="examen.observacion" class="form-control form-control-sm observacion-input"
                            :class="{ 'mr-2': examen.validado == 1 }"
                            rows="2" placeholder="Nota..." :disabled="examen.validado == 1"></textarea>
                          <span v-if="examen.validado == 1" class="badge badge-success-soft font-weight-bold flex-shrink-0" style="font-size: 0.72rem;">
                            <i class="fas fa-check-circle mr-1"></i> Validado
                          </span>
                        </div>
                        <div class="col-lg-3 text-right pr-3">
                          <div v-if="examen.valores_referencia != 0"
                            class="ref-value-box text-gray-600 font-weight-bold px-1 py-1" style="font-size: 0.75rem;">
                            {{ examen.valores_referencia }} <small class="ml-1">{{ examen.unidad }}</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>

                  <!-- CASE: STANDALONE -->
                  <div v-else class="list-group-item px-3 py-1 border-bottom border-light">
                    <div class="row align-items-center no-gutters">
                      <div class="col-lg-3 d-flex align-items-center">
                        <div v-if="_can('deleted.results')" class="mr-2 flex-shrink-0" style="width: 24px;">
                          <div v-if="entry.id_detalle_resultado" class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              :id="`check_entry_${entry.id}`"
                              :value="entry"
                              v-model="selectedDetalles"
                            />
                            <label class="custom-control-label cursor-pointer" :for="`check_entry_${entry.id}`"></label>
                          </div>
                        </div>
                        <span class="font-weight-bold text-dark text-sm">{{ entry.nombre }}</span>
                      </div>
                      <div class="col-lg-3">
                        <texto v-if="entry.tipo === 'texto'" v-model="entry.resultado" :validado="entry.validado"></texto>
                        <numerico v-if="entry.tipo === 'numero'" v-model="entry.resultado" :validado="entry.validado"></numerico>
                        <opciones v-if="entry.tipo === 'opcion'" v-model="entry.resultado" :examen="entry.examen_rel" :validado="entry.validado">
                        </opciones>
                      </div>
                      <div class="col-lg-3 px-3 d-flex align-items-center">
                        <textarea v-model="entry.observacion" class="form-control form-control-sm observacion-input"
                          :class="{ 'mr-2': entry.validado == 1 }"
                          rows="2" placeholder="Nota..." :disabled="entry.validado == 1"></textarea>
                        <span v-if="entry.validado == 1" class="badge badge-success-soft font-weight-bold flex-shrink-0" style="font-size: 0.72rem;">
                          <i class="fas fa-check-circle mr-1"></i> Validado
                        </span>
                      </div>
                      <div class="col-lg-3 text-right pr-3">
                        <div v-if="entry.valores_referencia != 0"
                          class="ref-value-box text-gray-600 font-weight-bold px-1 py-1" style="font-size: 0.75rem;">
                          {{ entry.valores_referencia }} <small class="ml-1">{{ entry.unidad }}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-footer bg-light border-top p-3">
                <div class="row align-items-center">
                  <div class="col-lg-6">
                    <div class="d-flex align-items-center">
                      <i class="fas fa-user-md text-muted mr-2"></i>
                      <div class="flex-grow-1">
                        <label class="text-xs text-uppercase font-weight-bold text-muted mb-1 d-block">Profesional
                          Responsable</label>
                        <v-select-user v-model="area.id_profesional"></v-select-user>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-12">
              <button class="btn btn-success btn-sm" @click="save()">
                <i class="fas fa-save fa-fw text-white-50"></i>
                Guardar Resultados
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Eliminar / Anular Resultados -->
    <modal-eliminar-resultados
      ref="modalEliminar"
      v-if="_can('deleted.results')"
      @eliminado="onResultadosEliminados"
      @cancelar="selectedDetalles = []"
    ></modal-eliminar-resultados>

    <!-- Floating Action Bar when items are selected -->
    <transition name="slide-up">
      <div
        v-if="_can('deleted.results') && selectedDetalles.length > 0"
        class="floating-selection-bar shadow-lg d-flex align-items-center justify-content-between px-3 py-2 rounded-pill"
      >
        <div class="d-flex align-items-center mr-3">
          <span class="badge badge-danger rounded-circle mr-2 d-flex align-items-center justify-content-center font-weight-bold" style="width: 22px; height: 22px; font-size: 0.72rem;">
            {{ selectedDetalles.length }}
          </span>
          <span class="text-white small font-weight-bold">
            {{ selectedDetalles.length === 1 ? '1 examen seleccionado' : `${selectedDetalles.length} exámenes seleccionados` }}
          </span>
        </div>
        <div class="d-flex align-items-center">
          <button
            type="button"
            class="btn btn-link text-white-50 btn-sm small py-0 px-2 mr-2 font-weight-bold text-decoration-none"
            @click="selectedDetalles = []"
            title="Limpiar selección"
          >
            <i class="fas fa-times mr-1"></i> Deseleccionar
          </button>
          <button
            type="button"
            class="btn btn-danger btn-sm font-weight-bold rounded-pill px-3 shadow-sm"
            @click="abrirModalEliminar(selectedDetalles)"
          >
            <i class="fas fa-trash-alt mr-1"></i> Eliminar seleccionados
          </button>
        </div>
      </div>
    </transition>
  </main>
</template>
<script>
import PageHeaderCompact from "../../../../components/layouts/content/page-header-compact";
import OrdenTrabajoField from "../../../../components/common/OrdenTrabajoField";
import texto from "./tipos/texto";
import numerico from "./tipos/numerico";
import opciones from "./tipos/opciones";
import Swal from "sweetalert2";
import resultadosLaboratorioService from "../../../../services/resultadosLaboratorioService";
//import asignacionAreasService from "../../../../services/asignacionAreasService";
import { isEmpty } from "lodash";
import VSelectUser from "@/components/common/vSelectUser.vue";
import modalEliminarResultados from "../baseConfigLaboratorio/resultadosExamenesProfesional/modalEliminarResultados.vue";

export default {
  components: {
    VSelectUser,
    PageHeaderCompact,
    OrdenTrabajoField,
    texto,
    numerico,
    opciones,
    modalEliminarResultados
  },
  data() {
    return {
      ordentrabajo: {},
      usuario: {},
      fecha: '',
      detalles: [],
      tieneRespuestas: false,
      resultado_laboratorio_id: null,
      selectedDetalles: [],
      areas: [],
      toma_muestra: '',
    }
  },
  watch: {
    ordentrabajo: {
      handler: async function () {
        await this.cargarDatosOrden();
      },
      deep: true
    },
    areas: {
      handler: function () {
        this.calcularMicroalbuminuriaCreatinina();
      },
      deep: true
    }
  },
  methods: {
    async cargarDatosOrden() {
      this.areas = [];
      this.selectedDetalles = [];
      if (!isEmpty(this.ordentrabajo)) {

        this.usuario = this.ordentrabajo.usuario;
        this.toma_muestra = this.ordentrabajo.toma_muestra;

        const respuestas = await resultadosLaboratorioService.showByOrdenTrabajo(this.ordentrabajo.id);

        if (!isEmpty(respuestas.data)) {
          this.tieneRespuestas = true;
          this.resultado_laboratorio_id = respuestas.data.id;
        } else {
          this.tieneRespuestas = false;
          this.resultado_laboratorio_id = null;
        }

        let examenes = [];

        const testWithSubtest = this.ordentrabajo.detalles.filter(x => x.examen.subexamen.length);
        const testWithoutSubtest = this.ordentrabajo.detalles.filter(x => x.examen.subexamen.length === 0);

        testWithSubtest.forEach(test => {
          examenes.push(...test.examen.subexamen.map(subtest => {

            let respuesta = '';
            let observacion = '';
            let validado = 0;
            let id_detalle_resultado = null;

            if (!isEmpty(respuestas.data)) {
              const tieneRespuesta = respuestas.data.detalles.find(x => parseInt(x.id_examen) === parseInt(subtest.id));
              if (tieneRespuesta !== undefined) {
                respuesta = tieneRespuesta.resultado;
                observacion = tieneRespuesta.observacion;
                validado = tieneRespuesta.validado !== undefined ? tieneRespuesta.validado : 0;
                id_detalle_resultado = tieneRespuesta.id;
              }
            }

            return {
              id: subtest.id,
              nombre: subtest.nombre,
              observacion: observacion,
              tipo: subtest.tipo,
              opciones: subtest.opciones,
              resultado: respuesta,
              validado: validado,
              id_detalle_resultado: id_detalle_resultado,
              valores_referencia: subtest.valores_referencia,
              unidad: subtest.unidad,
              id_area_rel: test.examen.area,
              id_examen_padre: test.examen.id,
              nombre_padre: test.examen.nombre || test.examen.descripcion || 'Examen',
              padre_orden: test.examen.orden,
              examen_rel: subtest
            }
          }));
        });

        examenes.push(...testWithoutSubtest.map(test => {

          let respuesta = '';
          let observacion = '';
          let validado = 0;
          let id_detalle_resultado = null;

          if (!isEmpty(respuestas.data)) {
            const tieneRespuesta = respuestas.data.detalles.find(x => parseInt(x.id_examen) === parseInt(test.id_examen));
            if (tieneRespuesta !== undefined) {
              respuesta = tieneRespuesta.resultado;
              observacion = tieneRespuesta.observacion;
              validado = tieneRespuesta.validado !== undefined ? tieneRespuesta.validado : 0;
              id_detalle_resultado = tieneRespuesta.id;
            }
          }
          return {
            id: test.examen.id,
            nombre: test.examen.nombre,
            tipo: test.examen.tipo,
            opciones: test.examen.opciones,
            id_area: test.examen.id_area,
            resultado: respuesta,
            observacion: observacion,
            validado: validado,
            id_detalle_resultado: id_detalle_resultado,
            valores_referencia: test.examen.valores_referencia,
            unidad: test.examen.unidad,
            id_area_rel: test.examen.area,
            id_examen_padre: test.examen.id_examen || test.examen.id,
            nombre_padre: (test.examen.examen_padre ? test.examen.examen_padre.nombre : null) ||
              (test.examen.padre ? test.examen.padre.nombre : null) ||
              (test.examen.examen ? test.examen.examen.nombre : null) ||
              test.examen.nombre,
            padre_orden: (test.examen.examen_padre ? test.examen.examen_padre.orden : null) ||
              (test.examen.padre ? test.examen.padre.orden : null) ||
              (test.examen.examen ? test.examen.examen.orden : null),
            examen_rel: test.examen
          }
        }));

        let areasConExamenes = {};

        // Iterar sobre los detalles de la orden de trabajo
        examenes.forEach(detalle => {
          let area = detalle.id_area_rel;
          if (!area) return;

          if (!areasConExamenes[area.id]) {
            areasConExamenes[area.id] = {
              id: area.id,
              nombre: area.nombre,
              id_profesional: null,
              items: []
            };
          }

          if (detalle.id_examen_padre && detalle.id_examen_padre !== detalle.id) {
            // Group by parent
            let parentId = detalle.id_examen_padre;
            let group = areasConExamenes[area.id].items.find(x => x.type === 'group' && x.id === parentId);

            if (!group) {
              group = {
                type: 'group',
                id: parentId,
                nombre: detalle.nombre_padre,
                orden: detalle.padre_orden,
                items: []
              };
              areasConExamenes[area.id].items.push(group);
            }
            group.items.push(detalle);
          } else if (detalle.examen_rel && detalle.examen_rel.subexamen && detalle.examen_rel.subexamen.length > 0) {
            // It's a parent with children (nested case)
            areasConExamenes[area.id].items.push({
              type: 'group',
              id: detalle.id,
              nombre: detalle.nombre_padre,
              orden: detalle.examen_rel ? detalle.examen_rel.orden : null,
              items: detalle.items || [] // This shouldn't happen here as it's flattened, but just in case
            });
          } else {
            // Standalone
            areasConExamenes[area.id].items.push({
              type: 'item',
              ...detalle
            });
          }
        });

        this.areas = Object.values(areasConExamenes).map(area => {
          // 1. Sort the items within each group if they are groups
          area.items.forEach(item => {
            if (item.type === 'group' && item.items) {
              item.items.sort((a, b) => {
                const oA = (a.examen_rel && a.examen_rel.orden !== null && a.examen_rel.orden !== undefined && a.examen_rel.orden !== "") ? parseInt(a.examen_rel.orden) : Infinity;
                const oB = (b.examen_rel && b.examen_rel.orden !== null && b.examen_rel.orden !== undefined && b.examen_rel.orden !== "") ? parseInt(b.examen_rel.orden) : Infinity;
                return oA - oB;
              });
            }
          });

          // 2. Sort the top-level items of the area (standalone and groups)
          area.items.sort((a, b) => {
            const getOrdenVal = (node) => {
              if (node.type === 'group') {
                if (node.orden !== undefined && node.orden !== null && node.orden !== "") return parseInt(node.orden);
                if (node.items && node.items.length) {
                  const firstItem = node.items[0];
                  if (firstItem.examen_rel && firstItem.examen_rel.examen_padre && firstItem.examen_rel.examen_padre.orden !== undefined && firstItem.examen_rel.examen_padre.orden !== null) {
                    return parseInt(firstItem.examen_rel.examen_padre.orden);
                  }
                }
                return Infinity;
              }
              const val = node.examen_rel ? node.examen_rel.orden : null;
              return (val !== undefined && val !== null && val !== "") ? parseInt(val) : Infinity;
            };

            return getOrdenVal(a) - getOrdenVal(b);
          });

          return area;
        });
        
        this.fecha = this.tieneRespuestas ? respuestas.data.fecha : this.ordentrabajo.fecha;

        // asignar profesional a cada area segun los resultados
        if (!isEmpty(respuestas.data)) {
          this.areas.forEach(area => {
            // buscar resultados de examenes de esta area
            let examenesIds = [];
            area.items.forEach(entry => {
              if (entry.type === 'group') {
                examenesIds.push(...entry.items.map(x => x.id));
              } else {
                examenesIds.push(entry.id);
              }
            });

            const resultadosArea = respuestas.data.detalles.filter(x => examenesIds.includes(x.id_examen));
            // buscar profesional asignado a los resultados
            area.id_profesional = resultadosArea.length ? resultadosArea[0].id_profesional : null;
          });
        }
      } else {
        this.usuario = {};
        this.detalles = [];
      }
    },
    hasDeletableItems(area) {
      return this.getFlatDetallesFromArea(area).length > 0;
    },
    getFlatDetallesFromArea(area) {
      let list = [];
      if (!area || !area.items) return list;
      area.items.forEach((entry) => {
        if (entry.type === "group" && entry.items) {
          list.push(...entry.items.filter(e => e.id_detalle_resultado));
        } else if (entry.id_detalle_resultado) {
          list.push(entry);
        }
      });
      return list;
    },
    getSelectedForArea(area) {
      const flatItems = this.getFlatDetallesFromArea(area);
      const flatIds = flatItems.map((d) => d.id_detalle_resultado);
      return this.selectedDetalles.filter((d) => flatIds.includes(d.id_detalle_resultado));
    },
    isAreaAllSelected(area) {
      const flatItems = this.getFlatDetallesFromArea(area);
      if (!flatItems.length) return false;
      return flatItems.every((d) =>
        this.selectedDetalles.some((s) => s.id_detalle_resultado === d.id_detalle_resultado)
      );
    },
    toggleSelectArea(area, event) {
      const checked = event.target.checked;
      const flatItems = this.getFlatDetallesFromArea(area);
      if (checked) {
        flatItems.forEach((d) => {
          if (!this.selectedDetalles.some((s) => s.id_detalle_resultado === d.id_detalle_resultado)) {
            this.selectedDetalles.push(d);
          }
        });
      } else {
        const idsToRemove = flatItems.map((d) => d.id_detalle_resultado);
        this.selectedDetalles = this.selectedDetalles.filter(
          (d) => !idsToRemove.includes(d.id_detalle_resultado)
        );
      }
    },
    abrirModalEliminar(seleccionados = null) {
      const examenesAEliminar = seleccionados || this.selectedDetalles;
      if (!examenesAEliminar || !examenesAEliminar.length) {
        Swal.fire("Atención", "Debe seleccionar al menos un examen para anular.", "warning");
        return;
      }

      const usuarioCopia = {
        ...this.usuario,
        tipo_documento: this.usuario.tipo_documento || {
          codigo: (this.usuario.tipo_documento_rel ? this.usuario.tipo_documento_rel.abreviacion : 'DOC')
        }
      };

      const order = {
        id: this.resultado_laboratorio_id,
        orden_trabajo: {
          ...this.ordentrabajo,
          usuario: usuarioCopia,
          toma_muestra: this.toma_muestra
        }
      };

      const formattedExamenes = examenesAEliminar.map(item => ({
        id: item.id_detalle_resultado,
        id_examen: item.id,
        resultado: item.resultado,
        nombre: item.nombre,
        examenes: {
          id: item.id,
          nombre: item.nombre
        }
      }));

      const idSede = this.ordentrabajo && this.ordentrabajo.sede
        ? (this.ordentrabajo.sede.ID || this.ordentrabajo.sede.id)
        : (this.ordentrabajo.id_sede || null);

      this.$refs.modalEliminar.abrir(order, formattedExamenes, idSede);
    },
    async onResultadosEliminados() {
      this.selectedDetalles = [];
      await this.cargarDatosOrden();
    },
    calcularMicroalbuminuriaCreatinina() {
      let malb = null;
      let crea = null;
      let targetItem = null;

      this.areas.forEach(area => {
        area.items.forEach(entry => {
          if (entry.type === 'group') {
            entry.items.forEach(item => {
              const abbr = item.examen_rel ? item.examen_rel.abbr_name : '';
              if (abbr === 'mALB-O') {
                malb = item;
              } else if (abbr === 'CREA-O') {
                crea = item;
              } else if (abbr === 'mALB-CR') {
                targetItem = item;
              }
            });
          } else {
            const abbr = entry.examen_rel ? entry.examen_rel.abbr_name : '';
            if (abbr === 'mALB-O') {
              malb = entry;
            } else if (abbr === 'CREA-O') {
              crea = entry;
            } else if (abbr === 'mALB-CR') {
              targetItem = entry;
            }
          }
        });
      });

      if (malb && crea && targetItem) {
        const valMalb = parseFloat(malb.resultado);
        const valCrea = parseFloat(crea.resultado);

        if (!isNaN(valMalb) && !isNaN(valCrea) && valCrea !== 0) {
          const calculated = ((valMalb / valCrea) * 100).toFixed(2);
          if (targetItem.resultado !== calculated) {
            targetItem.resultado = calculated;
          }
        } else {
          if (targetItem.resultado !== '') {
            targetItem.resultado = '';
          }
        }
      }
    },
    async save() {
      try {
        let resultados = [];

        // buscar areas que tienen resultados
        const areasConExamen = this.areas.filter(area => {
          return area.items.some(entry => {
            if (entry.type === 'group') {
              return entry.items.some(e => e.resultado !== '');
            }
            return entry.resultado !== '';
          });
        });

        // validar que todas las areas tengan un profesional asignado
        const areasSinProfesional = areasConExamen.filter(x => x.id_profesional === null);

        if (areasSinProfesional.length) {
          // concat all areas without professional
          const areasNames = areasSinProfesional.map(x => x.nombre).join(', ');
          await Swal.fire("Ups!", `Debe asignar un profesional a los resultados de area ` + areasNames, "error");
          return;
        }

        this.areas.forEach(x => {
          x.items.forEach(entry => {
            if (entry.type === 'group') {
              entry.items.forEach(e => {
                resultados.push({
                  nombre: e.nombre,
                  id_examen: e.id,
                  resultado: e.resultado,
                  id_profesional: x.id_profesional,
                  valores_referencia: e.valores_referencia,
                  observacion: e.observacion,
                });
              });
            } else {
              resultados.push({
                nombre: entry.nombre,
                id_examen: entry.id,
                resultado: entry.resultado,
                id_profesional: x.id_profesional,
                valores_referencia: entry.valores_referencia,
                observacion: entry.observacion,
              });
            }
          });
        });

        let resultados_laboratorios = {
          id_orden_trabajo: this.ordentrabajo.id,
          fecha: this.fecha,
          resultados: resultados
        }

        console.log(resultados_laboratorios);
        this.LoaderSpinnerShow();

        if (this.tieneRespuestas) {
          await resultadosLaboratorioService.update(resultados_laboratorios);
        } else {
          await resultadosLaboratorioService.store(resultados_laboratorios);
          this.tieneRespuestas = true;
        }

        this.LoaderSpinnerHide();

        Swal.fire("Datos Guardados con exito", "", "success");
        this.limpiarCampos();


      } catch (error) {
        console.log(error);
        this.LoaderSpinnerHide();
        Swal.fire("Upss", "Ocurrio un error al procesar la solicitud", "error");
      }
    },
    limpiarCampos() {
      this.ordentrabajo = {};
      this.usuario = {};
      this.areas = [];
      this.tieneRespuestas = false;
      this.resultado_laboratorio_id = null;
      this.selectedDetalles = [];
      this.fecha = '';
    }
  },
  created() {
    // get work order id from url
    const workOrderId = this.$route.params?.workOrderId;
    if (workOrderId) {
      // next tick to ensure the component is mounted
      this.$nextTick(() => {
        this.$refs.ordenTrabajoField.setIdOrden(workOrderId);
      });
      // get date from query params if present
      const date = this.$route.query?.orderDate;
      if (date) {
        this.fecha = date
      }
    }
  }

}
</script>

<style scoped>
.ref-value-box {
  background-color: #f1f5f9;
  border-radius: 4px;
  display: inline-block;
  max-width: 100%;
  white-space: normal;
  word-wrap: break-word;
  text-align: right;
  line-height: 1.2;
}

.text-gray-600 {
  color: #475569 !important;
}

.font-weight-600 {
  font-weight: 600;
}

.bg-gray-100 {
  background-color: #f1f5f9 !important;
}

.badge-success-soft {
  background-color: rgba(28, 200, 138, 0.15);
  color: #169b6b;
}

.observacion-input {
  background-color: #ffffff !important;
  border: 1px solid #d1d5db;
  border-radius: 4px;
}

.observacion-input:disabled {
  background-color: #e9ecef !important;
  border-color: #ced4da !important;
  color: #6c757d;
  cursor: not-allowed;
}

.floating-selection-bar {
  position: fixed;
  bottom: 25px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1040;
  background-color: #1e293b;
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.4), 0 8px 10px -6px rgba(0, 0, 0, 0.25);
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.25s ease-out;
}

.slide-up-enter,
.slide-up-leave-to {
  transform: translate(-50%, 20px);
  opacity: 0;
}
</style>
